// Import createSlice from redux toolkit
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  API_STATUS,
  CUSTOM_NUMBER_INPUT_MODULES
} from '../../components/SequenceNumberFormat/Other';
import CustomNumberFormatService from '../../services/CustomNumberFormat';

export interface CustomNumberFormatState {
  contactSequence: any[];
  status: API_STATUS;
  isLoading: boolean;
  fullContact: any;
}

// initialized initial state of custom number format
const initialState: CustomNumberFormatState = {
  contactSequence: [],
  status: API_STATUS.IDLE,
  isLoading: false,
  fullContact: {}
};

export const fetchContactCustomNumberFormat = createAsyncThunk(
  'fetch_contact_custom_number_formats',
  async () => {
    let CONTACT_SEQUENCE_CODE_RESPONSE: any =
      await CustomNumberFormatService.getCustomNumberFormat(
        "PEOPLE_EMPLOYEE"
      );
    return {
      CONTACT_SEQUENCE_CODE_RESPONSE
    };
  }
);

// Creating slice for custom number format
export const CustomNumberFormatSlice = createSlice({
  name: 'custom_number_format',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactCustomNumberFormat.pending, (state) => {
        state.status = API_STATUS.LOADING;
      })
      .addCase(fetchContactCustomNumberFormat.fulfilled, (state, action) => {
        state.status = API_STATUS.IDLE;
        let data: any = action.payload;
        state.contactSequence = [];

        data.CONTACT_SEQUENCE_CODE_RESPONSE.sequenceFormats.forEach(
          (data: any) => {
            let payload = {
              text: data.sequenceCode,
              ...data
            };
            state.contactSequence.push(payload);
          }
        );
      })
  }
});

// Export custom number format data to display
export const selectContactCustomNumbersFormats = (state: any) =>
  state.customNumberFormat.contactSequence;

// Export custom number format slice reducer
export default CustomNumberFormatSlice.reducer;
